export const ZERO_WIDTH_RE = /(?:\u200B|\u200C|\u200D|\uFEFF|\u2060|\u180E)/gu

export function isZeroWidthOrEmpty(str: string | null | undefined): boolean {
    if (str == null) return true // null/undefined
    // remove zero-widths, then trim regular whitespace
    const visible = str.replace(ZERO_WIDTH_RE, '').trim()
    return visible.length === 0
}
